import React from "react";
import {
  FaBrain,
  FaSearch,
  FaCalendarAlt,
  FaHandshake,
  FaBox,
  FaClipboardList,
  FaTruck,
  FaDollarSign,
  FaArrowRight,
} from "react-icons/fa";
import intelliSalesImage from "../../../Asset/IntellisalesIm1.png";
import "./IntelliSales.css";

const IntelliSales = () => {
  const aiFeatures = [
    {
      icon: <FaBrain className="feature-icon brain" />,
      title: "Analyzes 1,000+ store inventories",
      description: "learning from historical purchase patterns.",
    },
    {
      icon: <FaSearch className="feature-icon search" />,
      title: "Spots low-stock products early",
      description: "before shelves go empty.",
    },
    {
      icon: <FaCalendarAlt className="feature-icon calendar" />,
      title: "Schedules & prioritizes visits",
      description:
        "ensuring reps visit stores with the highest replenishment need and clustered orders.",
    },
    {
      icon: <FaHandshake className="feature-icon handshake" />,
      title: "While with customers — bundle slower, high-margin items with fast-sellers,",
      description: "boosting profitability.",
    },
  ];

  const results = [
    {
      icon: <FaBox className="result-icon" />,
      text: "Always high-volume orders",
    },
    {
      icon: <FaClipboardList className="result-icon" />,
      text: "Uninterrupted consumer supply",
    },
    {
      icon: <FaTruck className="result-icon" />,
      text: "Optimized delivery routes",
    },
    {
      icon: <FaDollarSign className="result-icon" />,
      text: "Increased margins from smart product mix",
    },
  ];

  return (
    <section className="intellisales-ai-section">
      <div className="intellisales-ai-container">
        {/* Header */}
        <div className="section-header">
          <h1 className="main-title">IntelliSales Platform</h1>
          <p className="main-tagline">
            <span className="emphasis">
              "Less sales work, more Revenue" - Revolve Your sales process.
            </span>
          </p>
          <span className="emphasis">
            Reps'll be guided to the customers where orders are waiting.
          </span>
        </div>

        <div className="content-grid">
          {/* Left Side: How AI Works */}
          <div className="ai-explanation">
            <h2 className="section-title">
              <span className="ai-badge">B2B</span> : How it works?
            </h2>

            <div className="ai-features">
              {aiFeatures.map((feature, index) => (
                <div key={index} className="feature-card">
                  <div className="feature-icon-wrapper">{feature.icon}</div>
                  <div className="feature-content">
                    <h3 className="feature-title">{feature.title}</h3>
                    <p className="feature-desc">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Results Section */}
            <div className="results-section">
              <h3 className="results-title">
                <span className="rocket-icon">🚀</span> Result :
              </h3>
              <div className="results-grid">
                {results.map((result, index) => (
                  <div key={index} className="result-item">
                    {result.icon}
                    <span>{result.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Side: Visual Representation */}
          <div className="visual-section">
            <img
              src={intelliSalesImage}
              alt="IntelliSales AI Dashboard"
              className="intellisales-dashboard-image"
            />

            {/* Ultimate Transformation */}
            <div className="transformation-banner">
              <span className="transform-icon">🔥</span>
              <span className="transform-text">
                <strong>Ultimately :</strong> Manual Sales Reps
              </span>
              <FaArrowRight className="transform-arrow" />
              <span className="transform-result">Automated AI-driven Replenishment!</span>
            </div>

            {/* Floating Insights */}
            <div className="floating-insight insight-1">
              <span className="insight-icon">📊</span>
              <span className="insight-text">Live Inventory Analysis</span>
            </div>
            <div className="floating-insight insight-2">
              <span className="insight-icon">🎯</span>
              <span className="insight-text">Smart Prioritization</span>
            </div>
            <div className="floating-insight insight-3">
              <span className="insight-icon">💡</span>
              <span className="insight-text">Profit Optimization</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntelliSales;
